// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/DashboardLayout.css */

/* ルートのレイアウト枠。100vh は使わず 100dvh or 自然高 */
.dashboard-layout {
  display: flex;
  flex-direction: column;
  min-height: 100dvh; /* 以前の height:100vh を安全化 */
}

/* メイン行。子にスクロールを委ねるため min-height:0 が肝 */
.main-layout {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;        /* ← Safari で必須 */
  overflow: visible;     /* まずは visible。必要に応じて hidden に戻してOK */
}

/* Sidebar - 固定幅・非スクロール（PC想定） */
.sidebar {
  width: 250px;
  background-color: #f4f4f4;
  padding: 1rem;
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

/* Sidebar リンク共通 */
.sidebar-link {
  display: block;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  color: #161616;
  text-decoration: none;
  font-weight: normal;
  transition: background-color 0.2s ease, font-weight 0.2s ease;
}

/* ホバー */
.sidebar-link:hover {
  background-color: #e0e0e0;
  color: #0f62fe;
}

/* アクティブ状態（現在ページ） */
.sidebar-link.active {
  background-color: #e6f0ff;
  color: #0f62fe;
  font-weight: bold;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar li {
  margin-bottom: 1rem;
}

.sidebar a {
  text-decoration: none;
  color: #161616;
}

/* Main content は独立スクロール */
.main-content {
  flex: 1 1 auto;
  min-height: 0;                     /* ← Safari で必須 */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;  /* iOS 慣性スクロール */
  padding: 1rem;
  background-color: #ffffff;
}

/* モバイル対応: サイドバーを隠してスライド式に */
@media (max-width: 1024px) {
  .sidebar {
    position: fixed;
    left: 0;
    top: 0;                            /* 固定ヘッダーがあるなら 3rem 等に調整 */
    height: 100dvh;                    /* 100% → 100dvh で安全化 */
    transform: translateX(-100%);
    z-index: 1000;
    overflow-y: auto;                  /* モバイル時はサイドバー自身もスクロール */
    -webkit-overflow-scrolling: touch;
  }

  .sidebar.open {
    transform: translateX(0);
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  }

  .main-layout {
    flex-direction: column;
    min-height: 0; /* 念のため保持 */
    overflow: visible;
  }

  .dashboard-layout {
    min-height: 100dvh;
  }

  .sidebar-link {
    text-decoration: none;
    color: #333;
    font-weight: normal;
  }

  .sidebar-link:hover {
    text-decoration: underline;
    color: #0f62fe;
  }

  .main-content {
    background: #fff;
    flex: 1 1 auto;
    min-height: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardLayout.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB,EAAE,0BAA0B;AAChD;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,cAAc;EACd,aAAa,SAAS,iBAAiB;EACvC,iBAAiB,MAAM,qCAAqC;AAC9D;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA,QAAQ;AACR;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,aAAa,sBAAsB,iBAAiB;EACpD,gBAAgB;EAChB,iCAAiC,GAAG,gBAAgB;EACpD,aAAa;EACb,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;IACf,OAAO;IACP,MAAM,6BAA6B,0BAA0B;IAC7D,cAAc,qBAAqB,uBAAuB;IAC1D,4BAA4B;IAC5B,aAAa;IACb,gBAAgB,mBAAmB,wBAAwB;IAC3D,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;IACtB,aAAa,EAAE,WAAW;IAC1B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,aAAa;EACf;AACF","sourcesContent":["/* src/components/DashboardLayout.css */\n\n/* ルートのレイアウト枠。100vh は使わず 100dvh or 自然高 */\n.dashboard-layout {\n  display: flex;\n  flex-direction: column;\n  min-height: 100dvh; /* 以前の height:100vh を安全化 */\n}\n\n/* メイン行。子にスクロールを委ねるため min-height:0 が肝 */\n.main-layout {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;        /* ← Safari で必須 */\n  overflow: visible;     /* まずは visible。必要に応じて hidden に戻してOK */\n}\n\n/* Sidebar - 固定幅・非スクロール（PC想定） */\n.sidebar {\n  width: 250px;\n  background-color: #f4f4f4;\n  padding: 1rem;\n  flex-shrink: 0;\n  transition: transform 0.3s ease;\n}\n\n/* Sidebar リンク共通 */\n.sidebar-link {\n  display: block;\n  padding: 0.5rem 0.75rem;\n  border-radius: 4px;\n  color: #161616;\n  text-decoration: none;\n  font-weight: normal;\n  transition: background-color 0.2s ease, font-weight 0.2s ease;\n}\n\n/* ホバー */\n.sidebar-link:hover {\n  background-color: #e0e0e0;\n  color: #0f62fe;\n}\n\n/* アクティブ状態（現在ページ） */\n.sidebar-link.active {\n  background-color: #e6f0ff;\n  color: #0f62fe;\n  font-weight: bold;\n}\n\n.sidebar ul {\n  list-style: none;\n  padding: 0;\n}\n\n.sidebar li {\n  margin-bottom: 1rem;\n}\n\n.sidebar a {\n  text-decoration: none;\n  color: #161616;\n}\n\n/* Main content は独立スクロール */\n.main-content {\n  flex: 1 1 auto;\n  min-height: 0;                     /* ← Safari で必須 */\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;  /* iOS 慣性スクロール */\n  padding: 1rem;\n  background-color: #ffffff;\n}\n\n/* モバイル対応: サイドバーを隠してスライド式に */\n@media (max-width: 1024px) {\n  .sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;                            /* 固定ヘッダーがあるなら 3rem 等に調整 */\n    height: 100dvh;                    /* 100% → 100dvh で安全化 */\n    transform: translateX(-100%);\n    z-index: 1000;\n    overflow-y: auto;                  /* モバイル時はサイドバー自身もスクロール */\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);\n  }\n\n  .main-layout {\n    flex-direction: column;\n    min-height: 0; /* 念のため保持 */\n    overflow: visible;\n  }\n\n  .dashboard-layout {\n    min-height: 100dvh;\n  }\n\n  .sidebar-link {\n    text-decoration: none;\n    color: #333;\n    font-weight: normal;\n  }\n\n  .sidebar-link:hover {\n    text-decoration: underline;\n    color: #0f62fe;\n  }\n\n  .main-content {\n    background: #fff;\n    flex: 1 1 auto;\n    min-height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
